module.exports = __webpack_public_path__ + "img/MTCIAGRI.8cfa83fb.png";